import {CompanySelectorProps, companyType} from "@ots-frontend/ots-data";
import {CompanyMultiSelect, CompanyMultiSelectProps} from "./CompanyMultiSelect";

export type OperatorCompanyMultiSelectProps = CompanyMultiSelectProps & {
  selector?: Omit<CompanySelectorProps, 'companyType'>
}

export const OperatorCompanyMultiSelect = (props: OperatorCompanyMultiSelectProps) => {
  const {selector, ...rest} = props;
  return (
    <CompanyMultiSelect
      {...rest}
      selector={{
        ...selector,
        companyType: companyType.operator,
      }}
    />
  );
};
